module.exports = __webpack_public_path__ + "img/2V.6a529d9e.jpg";